import { render, staticRenderFns } from "./InformVirtualList.vue?vue&type=template&id=42f4fbe5&"
import script from "./InformVirtualList.vue?vue&type=script&lang=js&"
export * from "./InformVirtualList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports